var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75437 16.05528c.41347.5178 1.16841.60237 1.6862.1889a1.2002 1.2002 0 00.00713-.00573l7.55227-6.12535 7.55226 6.12534c.51465.41742 1.27024.33859 1.68765-.17606a1.19926 1.19926 0 00.00572-.0071c.41757-.52291.33516-1.28475-.18457-1.70628L12.6299 7.5109c-.36716-.29779-.89268-.29779-1.25984 0L2.93895 14.349c-.51972.42152-.60213 1.18335-.18458 1.70627z",
    className: "chevron-up_svg__outline",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

export default __webpack_public_path__ + "ondemand/static/e3056e037/icons/chevron-up.svg";
export { SvgChevronUp as ReactComponent };